interface ProfitInputs {
  revenue?: number | null
  costPrice?: number | null
  salesQuantity?: number | null
  returns?: number | null
}

export function approximateProfit({
  revenue,
  costPrice,
  salesQuantity,
  returns,
}: ProfitInputs): number {
  const netUnits = (salesQuantity ?? 0) - (returns ?? 0)
  return (revenue ?? 0) - (costPrice ?? 0) * netUnits
}
